import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { classMap as o } from '../../../../node_modules/lit-html/directives/class-map.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import '../../atoms/buttons/icon-button/index.js';
import { disableBodyScroll, enableBodyScroll, isEmpty } from '../../utilities/behavior-helpers/index.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import '../country-selector/index.js';
import css_248z from './global-nav.scss.js';
import { handleLangChange, renderLangOptions } from './helpers.js';
import img$1 from '../../../../assets/images/cross-icon.svg.js';
import img from '../../../../assets/images/modal-toggle.svg.js';

// @ts-ignore
class GlobalNav extends s {
    constructor() {
        super(...arguments);
        this.rtl = false;
        this.isInMainNavigation = false;
        this.isWithAlert = false;
        this.modalOpen = false;
        this.modalClosing = false;
        this.focusStartEl = null;
        this.focusEndEl = null;
        this.closeButton = null;
        this.closeOnEscape = () => {
            this.addEventListener('keydown', (event) => {
                if (event.key === 'Escape')
                    this.handleModalClose();
            });
        };
    }
    focusTrap() {
        var _a, _b;
        const modalContainer = this.shadowRoot.querySelector('.modal-container');
        if (!this.focusStartEl) {
            this.focusStartEl = document.createElement('input');
            this.focusStartEl.setAttribute('aria-disabled', 'true');
            this.focusStartEl.setAttribute('aria-hidden', 'true');
            this.focusStartEl.setAttribute('tabindex', '-1');
        }
        (_a = modalContainer === null || modalContainer === void 0 ? void 0 : modalContainer.querySelector('.modal-inner')) === null || _a === void 0 ? void 0 : _a.prepend(this.focusStartEl);
        if (!this.focusEndEl) {
            this.focusEndEl = document.createElement('input');
            this.focusEndEl.setAttribute('aria-disabled', 'true');
            this.focusEndEl.setAttribute('aria-hidden', 'true');
            (_b = modalContainer === null || modalContainer === void 0 ? void 0 : modalContainer.querySelector('.modal-inner')) === null || _b === void 0 ? void 0 : _b.append(this.focusEndEl);
            this.focusEndEl.addEventListener('focus', () => {
                var _a, _b, _c;
                this.closeButton = (_b = (_a = this.renderRoot
                    .querySelector('icon-button')) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('button');
                (_c = this.closeButton) === null || _c === void 0 ? void 0 : _c.focus();
            });
        }
        this.focusStartEl.focus();
        this.focusStartEl.blur();
    }
    renderLangDropdown() {
        var _a, _b;
        return ((_b = (_a = this.selectedCountry) === null || _a === void 0 ? void 0 : _a.langOptions) === null || _b === void 0 ? void 0 : _b.length)
            ? x `<select aria-label="Country selector" name="language" @change="${(e) => handleLangChange(e)}">${renderLangOptions(this.selectedCountry.langOptions)}</select>`
            : null;
    }
    handleModalOpen() {
        this.modalOpen = true;
        this.focusTrap();
        this.closeOnEscape();
        disableBodyScroll();
        window.CVTModalTargetElement = this.renderRoot.querySelector('.modal-toggle');
    }
    handleModalClose(setFocus = false) {
        var _a;
        this.modalClosing = true;
        if (setFocus) {
            const countrySelectorBtn = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.modal-toggle');
            countrySelectorBtn === null || countrySelectorBtn === void 0 ? void 0 : countrySelectorBtn.focus();
        }
        setTimeout(() => {
            var _a;
            this.modalClosing = false;
            this.modalOpen = false;
            enableBodyScroll();
            (_a = window.CVTModalTargetElement) === null || _a === void 0 ? void 0 : _a.focus();
        }, 300);
    }
    addUnderlineOnHover() {
        var _a;
        const links = (_a = this.shadowRoot.querySelector('[name="links"]')) === null || _a === void 0 ? void 0 : _a.assignedElements();
        links === null || links === void 0 ? void 0 : links.forEach(link => {
            /* eslint-disable no-return-assign, no-param-reassign */
            link.addEventListener('mouseenter', () => (link.style.textDecoration = 'underline'));
            link.addEventListener('mouseleave', () => (link.style.textDecoration = 'none'));
        });
    }
    firstUpdated() {
        this.addUnderlineOnHover();
    }
    connectedCallback() {
        super.connectedCallback();
        const alertBanner = document.querySelector('alert-banner');
        if (alertBanner) {
            this.isWithAlert = true;
        }
    }
    renderCountrySelect() {
        var _a, _b;
        return x `<button class="modal-toggle" type="button" @click="${this.handleModalOpen}"><img loading="lazy" class="mobile-img" src="${((_a = this.selectedCountry) === null || _a === void 0 ? void 0 : _a.img)
            ? this.selectedCountry.img
            : img}" alt="Country Selector"> <span>${(_b = this.selectedCountry) === null || _b === void 0 ? void 0 : _b.title}</span> <img class="desktop-img" src="${img}" alt="Country Selector"></button>`;
    }
    render() {
        const modalClassMap = {
            'modal-container': true,
            open: this.modalOpen,
            rtl: this.rtl,
            closing: this.modalClosing,
        };
        return x `<nav class="global-nav ${o({
            'in-main-navigation': this.isInMainNavigation,
            rtl: this.rtl || isRTL(),
        })}"><div class="global-nav__inner"><div class="global-nav__ticker"><slot name="ticker"></slot></div><div class="global-nav__links"><slot name="links"></slot>${this.renderLangDropdown()}</div></div>${!isEmpty(this.selectedCountry) ? this.renderCountrySelect() : null}<div class="${o(modalClassMap)}" @click="${this.handleModalClose}" @keydown="${this.handleModalClose}"><div class="modal-inner" @click="${(e) => e.stopPropagation()}" @keydown="${(e) => e.stopPropagation()}"><icon-button class="close-button" .onClick="${() => this.handleModalClose()}" ariaLabel="close"><img slot="icon" src="${img$1}" alt="Close Modal Icon"></icon-button><slot name="modal"></slot></div></div></nav>`;
    }
}
GlobalNav.styles = css_248z;
__decorate([
    n({ type: Boolean })
], GlobalNav.prototype, "rtl", void 0);
__decorate([
    n({ type: Boolean })
], GlobalNav.prototype, "isInMainNavigation", void 0);
__decorate([
    n({ type: Object })
], GlobalNav.prototype, "selectedCountry", void 0);
__decorate([
    t()
], GlobalNav.prototype, "isWithAlert", void 0);
__decorate([
    t()
], GlobalNav.prototype, "modalOpen", void 0);
__decorate([
    t()
], GlobalNav.prototype, "modalClosing", void 0);
customElements.define('global-nav', GlobalNav);

export { GlobalNav };
